import script from "./question-preview.vue?vue&type=script&lang=tsx&setup=true"
export * from "./question-preview.vue?vue&type=script&lang=tsx&setup=true"

import "./question-preview.vue?vue&type=style&index=0&id=548af55e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-548af55e"]])

export default __exports__